var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTermsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43176"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 43175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.94824 9.76903C1.94824 6.28782 1.94824 4.54723 3.02971 3.46575C4.11119 2.38428 5.85179 2.38428 9.333 2.38428H13.0254C16.5065 2.38428 18.2472 2.38428 19.3286 3.46575C20.4101 4.54723 20.4101 6.28782 20.4101 9.76903V11.6152C20.4101 15.0964 20.4101 16.8371 19.3286 17.9185C18.2472 19 16.5065 19 13.0254 19H9.333C5.85179 19 4.11119 19 3.02971 17.9185C1.94824 16.8371 1.94824 15.0964 1.94824 11.6152V9.76903Z",
    stroke: "#1B224C",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.56348 2.38464V1",
    stroke: "#1B224C",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15.7949 2.38464V1",
    stroke: "#1B224C",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M1.94824 7.00049H20.4101",
    stroke: "#1B224C",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.8964 11.334L11.5174 9.73862C11.3211 9.65983 11.0854 9.64014 10.948 9.64014C10.7909 9.64014 10.5749 9.65983 10.3785 9.73862L5.9995 11.334C5.58713 11.4916 5.54785 11.7673 5.54785 11.8855C5.54785 12.0037 5.58713 12.2795 5.9995 12.437L6.19586 12.4961V14.1309C6.19586 14.3673 6.37259 14.5445 6.60824 14.5445C6.84388 14.5445 7.02061 14.3673 7.02061 14.1309V12.7916L7.78644 13.0673V14.9188C7.78644 15.7263 9.67157 16.1203 10.948 16.1203C12.2243 16.1203 14.1095 15.746 14.1095 14.9188V13.087L15.8964 12.437C16.3088 12.2992 16.3481 12.0037 16.3481 11.8855C16.3481 11.7673 16.3088 11.4916 15.8964 11.334ZM13.3044 14.8203C13.0687 14.9779 12.1851 15.293 10.9676 15.293C9.75011 15.293 8.84682 14.9779 8.63082 14.8203V13.3825L10.3981 14.0324C10.5945 14.1112 10.8301 14.1309 10.9676 14.1309C11.105 14.1309 11.3407 14.1112 11.5371 14.0324L13.3044 13.3825V14.8203ZM11.2425 13.2446C11.105 13.3037 10.8105 13.3037 10.673 13.2446L6.92242 11.8855L10.6534 10.5265C10.7909 10.4674 11.0854 10.4674 11.2229 10.5265L14.9735 11.8855L11.2425 13.2446Z",
    fill: "#1B224C",
    stroke: "#1B224C",
    strokeWidth: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTermsIcon);
export default __webpack_public_path__ + "static/media/termsIcon.82119d6e35c388f757f3f4e3b5936bb9.svg";
export { ForwardRef as ReactComponent };